module.exports = __webpack_public_path__ + "media/images/upload_6-ff32ce6d.png";